<ng-container *ngIf="item">
  <nz-date-picker #nzDatePickerComponent
    [nzDisabled]="item._readOnly"
    id="{{item._elementId}}"
    class="lhc-date-picker"
    nzFormat="MM/dd/yyyy"
    nzPlaceHolder="MM/DD/YYYY"
    nzSize="small"
    [(ngModel)]="item.value"
    (ngModelChange)="onChange($event)"
    (focus)="lhcDataService.setActiveRow(item)"
    attr.aria-required="{{ item._answerRequired }}"
  ></nz-date-picker>
  <!--(focus) is not triggered-->
</ng-container>
